import { send } from '../../../../src/network';
import { type HomePageWeb } from '../../../../src/types/HomePageWeb';

type Params = {
  search?: URLSearchParams;
};

export async function getApiV2Homepage({
  search = new URLSearchParams(),
}: Params = {}) {
  return await send<HomePageWeb>({
    path: '/api/v2/homepage/',
    query: search.size === 0 ? undefined : search,
    method: 'GET',
  });
}
